import React from "react"
import moment from "moment"
import { saveAs } from "file-saver"
import slugify from "slugify"
import { Storage } from "aws-amplify"
import { makeStyles } from "@material-ui/core/styles"
import IconButton from "@material-ui/core/IconButton"
import Link from "@material-ui/core/Link"
import DownloadIcon from "@material-ui/icons/GetApp"
import ViewIcon from "@material-ui/icons/Visibility"

import Table from "./Table"
import { Typography } from "@material-ui/core"

const useStyles = makeStyles((theme) => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
  content: {
    marginBottom: theme.spacing(3),
  },
  title: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
  },
  titleDocuments: {
    color: theme.palette.text.secondary,
    marginBottom: 0,
  },
  empty: {
    padding: theme.spacing(2),
  },
}))

export default function DocumentContent({ content, files, title }) {
  const classes = useStyles()
  const documentSlug = slugify(title)

  const filesTableTitles = [
    {
      content: "Name",
    },
    {
      content: "Added",
    },
    {
      content: "",
      width: 5,
    },
    {
      content: "",
      width: 5,
    },
  ]

  const createFilename = (file) => {
    const key = file.file.key
    const [filename] = key.split("/").slice(-1)
    const extension = filename.split(".").pop()
    const fileSlug = key.split(".")[0] // slugify(file.title)
    return `${documentSlug}_${fileSlug}.${extension}`
  }

  const fileOnClick = (key, filename, download) => {
    const storageArgs = {
      download: download ? true : false,
      expires: 60,
    }
    Storage.get(key, storageArgs)
      .then((response) => {
        saveAs(download ? response.Body : response, filename)
      })
      .catch((error) => {
        console.log("error", error)
      })
  }

  //React.useEffect(() => {}, [])
  const rows = []
  if (files.length && files[0]) {
    for (let i = 0, l = files.length; i < l; i++) {
      if (files[i] && files[i].file) {
        const key = files[i].file.key
        const filename = createFilename(files[i])
        rows.push([
          {
            content: (
              <Link
                href={filename}
                onClick={(e) => {
                  e.preventDefault()
                  fileOnClick(key, filename)
                }}
              >
                {files[i].title}
              </Link>
            ),
          },
          {
            content: moment(files[i].createdAt).format("DD/MM/YYYY"),
          },
          {
            content: (
              <IconButton
                href={filename}
                onClick={(e) => {
                  e.preventDefault()
                  fileOnClick(key, filename, "download")
                }}
                download
                title="Download file"
              >
                <DownloadIcon />
              </IconButton>
            ),
          },
          {
            content: (
              <IconButton
                href={filename}
                onClick={(e) => {
                  e.preventDefault()
                  fileOnClick(key, filename)
                }}
                title="View file online"
              >
                <ViewIcon />
              </IconButton>
            ),
          },
        ])
      }
    }
  }

  return (
    <div>
      <div className={classes.root}>
        {content && (
          <div className={classes.content}>
            <h4 className={classes.title}>Notes</h4>
            {content}
          </div>
        )}
        {rows && <h4 className={classes.titleDocuments}>Files</h4>}
      </div>
      {rows && rows.length ? (
        <Table titles={filesTableTitles} rows={rows} />
      ) : (
        <Typography className={classes.empty}>Processing&hellip;</Typography>
      )}
    </div>
  )
}
